export default {"src":"/_next/static/media/loader.469c429e.gif","height":70,"width":70,"blurWidth":0,"blurHeight":0};